<template>
  <div>
    <h3>Add Contact</h3>

    <b-form @submit.prevent="submitContact()" class="form-horizontal">
      <b-form-group label="Salutation" label-class="control-label">
        <b-form-input v-model="contact.salutation"></b-form-input>
      </b-form-group>

      <b-form-group label="First Name" label-class="control-label" :class="{ 'invalid-group': $v.contact.firstName.$error }">
        <b-form-input v-model="contact.firstName" :class="{ 'is-invalid': $v.contact.firstName.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.contact.firstName.$error">You must enter a first name.</span>
      </b-form-group>

      <b-form-group label="Last Name" label-class="control-label" :class="{ 'invalid-group': $v.contact.lastName.$error }">
        <b-form-input v-model="contact.lastName" :class="{ 'is-invalid': $v.contact.lastName.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.contact.lastName.$error">You must enter a last name.</span>
      </b-form-group>

      <b-form-group label="Title" label-class="control-label" :class="{ 'invalid-group': $v.contact.title.$error }">
        <b-form-input v-model="contact.title" :class="{ 'is-invalid': $v.contact.title.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.contact.title.$error">You must enter a title.</span>
      </b-form-group>
      
      <b-form-group label="Phone Number" label-class="control-label" :class="{ 'invalid-group': $v.contact.phoneNumber.$error }">
        <b-form-input v-model="contact.phoneNumber" :class="{ 'is-invalid': $v.contact.phoneNumber.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.contact.phoneNumber.$error">You must enter a phone number.</span>
      </b-form-group>

      <b-form-group label="Fax Number" label-class="control-label">
        <b-form-input v-model="contact.faxNumber"></b-form-input>
      </b-form-group>

      <b-form-group label="Street Address" label-class="control-label">
        <b-form-input v-model="contact.address"></b-form-input>
      </b-form-group>

      <b-form-group label="City" label-class="control-label">
        <b-form-input v-model="contact.city"></b-form-input>
      </b-form-group>

      <b-form-group label="State" label-class="control-label">
        <b-form-input v-model="contact.state"></b-form-input>
      </b-form-group>

      <b-form-group label="Zip Code" label-class="control-label">
        <b-form-input v-model="contact.zipCode"></b-form-input>
      </b-form-group>

      <b-form-group label="Email" label-class="control-label" :class="{ 'invalid-group': $v.contact.email.$error }">
        <b-form-input v-model="contact.email" :class="{ 'is-invalid': $v.contact.email.$error }"></b-form-input>
        <span class="span-feedback invalid-feedback" v-if="$v.contact.email.$error">You must enter an email.</span>
      </b-form-group>

      <div>
        <b-form-checkbox v-model="contact.authorizedSigner">Authorized Signer</b-form-checkbox>
      </div>

      <div>
        <b-form-checkbox v-model="contact.studentContact">Placements Contact (check this to use this contact for applying to opportunities)</b-form-checkbox>
      </div>

      <div>
        <b-form-checkbox v-model="contact.studentSupervisor">Student Supervisor (check this to allow selection as a site supervisor)</b-form-checkbox>
      </div>

      <b-button type="submit" class="pull-right btn-primary">Save</b-button> 
    </b-form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import { mapActions } from "vuex";
import sitesApi from "../../api/sites";

export default {
  data() {
    return {
      contact: {
        contactId: null,
        siteId: null,
        salutation: null,
        firstName: null,
        lastName: null,
        title: null,
        phoneNumber: null,
        faxNumber: null,
        address: null,
        city: null,
        state: null,
        zipCode: null,
        email: null,
        authorizedSigner: false,
        studentContact: false,
        studentSupervisor: false
      }
    };
  },

  props: {
    siteId: {
      required: false
    },

    contactId: {
      required: false
    }
  },

  validations: {
    contact: {
      firstName: {
        required
      },
      lastName: {
        required
      },
      title: {
        required
      },
      phoneNumber: {
        required
      },
      email: {
        required
      }
    }
  },

  computed: {},

  methods: {
    ...mapActions("contactForm", ["createContact", "editContact"]),

    getSiteAddress: function(siteId) {
      sitesApi
        .getSite(siteId)
        .then(response => {
          this.contact.siteId = response.data.siteId;
          this.contact.address = response.data.streetAddress;
          this.contact.city = response.data.city;
          this.contact.state = response.data.state;
          this.contact.zipCode = response.data.zip;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    getContact(contactId) {
      sitesApi
        .getSiteContact(contactId)
        .then(response => {
          this.contact = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    submitContact: function() {
      this.$v.contact.$touch();

      // only submit if the form is valid
      if (!this.$v.contact.$invalid) {
        if (this.contactId) {
          // if contact is set, edit function
          this.edit();
        } else {
          // otherwise, create new
          this.add();
        }
      }
    },

    add: function() {
      sitesApi
        .postSiteContact(this.contact)
        .then(() => {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("Your contact has been added.", "Success");

          this.$router.push({ name: "site", params: { siteId: this.siteId } });
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    edit: function() {
      sitesApi
        .postEditSiteContact(this.contact)
        .then(() => {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("Your contact has been edited.", "Success");

          this.$router.push({
            name: "site",
            params: { siteId: this.contact.siteId }
          });
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  },

  created() {
    if (!this.contactId) {
      this.getSiteAddress(this.siteId);
    } else {
      this.getContact(this.contactId);
    }
  }
};
</script>

<style>
.form-horizontal .control-label {
  padding-bottom: 0;
  font-size: 13px;
}
</style>
